// 刘志坤
// 平台判断（企业微信、钉钉、其他）

import * as dd from 'dingtalk-jsapi' // 钉钉jsapi
import {isSupport} from '@hybird/flutter'
import {getDeviceInfo, getLocation} from "@/utils/env";
import {isYKYByWidth} from "@/utils/tool";
import HomeNew from '@/views/home/homeNew.vue';

// 打包后失败了，先别用
// export function getImageUrl(fileName) {
//   return new URL(`../assets/images/${fileName}`.replaceAll('//', '/'), import.meta.url).href
// }
export const QYWX = 'QYWX'
export const DINGTALK = 'DINGTALK'
export const APP = 'APP'
export const FEISHU = 'FEISHU'
export const YKY = 'YKY'
export const KANGNING = 'KANGNING'

// 是否企业微信
export function checkQywx() {
  return /wxwork/i.test(navigator.userAgent)
}

// 是否手机端
export function checkMobile() {
  return window.navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )
}

export const isIOS = () => {
  const u = navigator.userAgent
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
  return isiOS
}

//是否是飞书
export function checkFeishu() {
  const userAgent = navigator.userAgent.toLowerCase()
  console.log(
          '是否是飞书环境',
          window.h5sdk,
          userAgent.includes('lark') || userAgent.includes('feishu')
  )
  return (
          window.h5sdk && (userAgent.includes('lark') || userAgent.includes('feishu'))
  )
}

// 是否康宁平台
export function checkKangning() {
  return getLocation('userToken')  || localStorage.getItem('isKANGNING')
}

export function generateUUID() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID()
  const bytes = new Uint8Array(16)
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(bytes)
  } else {
    for (let i = 0; i < 16; i++) bytes[i] = Math.floor(Math.random() * 256)
  }
  bytes[6] = (bytes[6] & 0x0f) | 0x40
  bytes[8] = (bytes[8] & 0x3f) | 0x80
  const toHex = n => (n + 256).toString(16).slice(1)
  const hex = Array.from(bytes, toHex)
  return `${hex[0]}${hex[1]}${hex[2]}${hex[3]}-${hex[4]}${hex[5]}-${hex[6]}${hex[7]}-${hex[8]}${hex[9]}-${hex[10]}${hex[11]}${hex[12]}${hex[13]}${hex[14]}${hex[15]}`
}

// 环境判断(APP,钉钉，企业微信，浏览器)
export function environmentJudge() {
  // 获取设备信息和用户代理
  const deviceInfo = getDeviceInfo();
  const isQywx = /wxwork/i.test(navigator.userAgent);
  
  // 优先判断是否为印控仪设备
  if (deviceInfo?.type === 3) {
    return YKY;
  }
  
  // 判断是否为APP环境
  if (deviceInfo?.type === 1 || isSupport()) {
    return APP;
  }
  
  // 根据屏幕宽度判断是否为YKY环境
  if (isYKYByWidth()) {
    // 在YKY环境下，进一步判断具体平台
    if (isQywx) {
      return QYWX;
    } else if (dd.env.platform != 'notInDingTalk') {
      return DINGTALK;
    } else if (checkFeishu()) {
      return FEISHU;
    } else if (checkKangning()) {
      return KANGNING;
    }
    return YKY;
  }
  
  // 非YKY环境下的平台判断
  if (isQywx) {
    return QYWX;
  } else if (dd.env.platform != 'notInDingTalk') {
    return DINGTALK;
  } else if (checkFeishu()) {
    return FEISHU;
  } else if (checkKangning()) {
    return KANGNING;
  }
  
  // 默认返回其他环境
  return isYKYByWidth() ? YKY : APP;
}

export function environmentJudgeText() {
  switch (environmentJudge()) {
    case APP:
      return 'APP'
    case DINGTALK:
      return '钉钉'
    case QYWX:
      return '企业微信'
    case FEISHU:
      return '飞书'
    case KANGNING:
      return '康宁'
    default:
      return ''
  }
}

export function acceptFileUper(list) {
  // const newList=list. toUpperCase()
  let upperArray = list.map((item) => item.toUpperCase())
  return [...list, ...upperArray]
}
